<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="modal_title">New Folder</div>
        <button mat-icon-button (click)="cancel()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="createFolderForm">

        <!-- Folder Name-->
        <mat-form-field class="w-full">
            <mat-label>Folder Name</mat-label>
            <input matInput [formControlName]="'folderName'" [value]="'Untitled Folder'" [(ngModel)]="folder.name"
                maxlength="400" (keydown.enter)="saveAndClose()">
            <mat-error *ngIf="createFolderForm.get('folderName').hasError('required')">
                Folder Name is required
            </mat-error>
        </mat-form-field>
       
        <mat-label>Description</mat-label>
        <textarea [formControlName]="'description'" [(ngModel)]="folder.description" id="description" rows="4"
            class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Write description about the folder ..."></textarea>

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

            </div>

            <div class="flex items-center mt-4 sm:mt-0">
                <button class="ml-auto sm:ml-0 mr-2" mat-stroked-button (click)="cancel()">
                    Cancel
                </button>
                <button
                    class="order-first sm:order-last"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="createFolderForm.disabled"
                    (click)="saveAndClose()">
                    <span *ngIf="!createFolderForm.disabled">
                        Create
                    </span>
                    <mat-progress-spinner
                        *ngIf="createFolderForm.disabled"
                        [diameter]="24"
                        [mode]="'indeterminate'">
                    </mat-progress-spinner>
                </button>
            </div>
        </div>
    </form>
</div>